export default {
    // dont translate the languages for the language switcher
    // so native speakers can find their language even so they dont speak the currently selected language
    LANGUAGE_SWITCHER_de: 'Deutsch',
    LANGUAGE_SWITCHER_en: 'English',
    LANGUAGE_SWITCHER_fr: 'Français',
    LANGUAGE_SWITCHER_es: 'Español',
    LANGUAGE_SWITCHER_it: 'Italiano',
};
